module.exports = __webpack_public_path__ + "static/media/45_B.d909e09a.png";